import { IBreadcrumbItem } from "@fluentui/react/lib/Breadcrumb";
import { Location } from "history";

/**
 * Parameters required to build GoApp breadcrumb
 */
export interface GoAppBreadcrumbParams {
    customerTitle: string;
    appName: string;
    location: Location;
    history: any;
}

/**
 * Builds breadcrumb items for GoApp
 */
export const buildGoAppBreadcrumb = (
    params: GoAppBreadcrumbParams
): IBreadcrumbItem[] => {

    const { customerTitle, appName, location, history } = params;
    const items: IBreadcrumbItem[] = [];

    // --------------------------------------------------------
    // ROOT ITEMS
    // --------------------------------------------------------
    items.push({
        text: 'ZedX Apps',
        key: "root",
        onClick: () => history.push("/")
    });

    items.push({
        text: appName,
        key: "app",
        onClick: () => history.push("/a7/welcome")
    });

    // --------------------------------------------------------
    // DETERMINE CURRENT PATH
    // --------------------------------------------------------
    let path = location.pathname || "";
    if ((!path || path === "/") && location.hash) {
        path = location.hash.replace(/^#/, "").split("?")[0].split("#")[0];
    }

    // --------------------------------------------------------
    // ROUTE-SPECIFIC BREADCRUMB ITEMS
    // --------------------------------------------------------
    if (path === "/a7/welcome") {
        items.push({ text: "Welcome", key: "welcome", isCurrentItem: true });
    }
    else if (path === "/a7/insights") {
        items.push({ text: "Insights", key: "insights", isCurrentItem: true });
    }
    else if (path.startsWith("/a7/updates")) {
        items.push({ text: "Updates", key: "updates", isCurrentItem: true });
    }
    else if (path.startsWith("/a7/outputs")) {
        items.push({ text: "Outputs", key: "outputs", isCurrentItem: true });
    }
    else if (path.startsWith("/a7/properties")) {
        items.push({ text: "Properties", key: "properties", isCurrentItem: true });
    }
    else if (path.startsWith("/not-authorised")) {
        items.push({ text: "Not Authorised", key: "not-authorised", isCurrentItem: true });
    }
    else {
        items.push({ text: "Not Found", key: "not-found", isCurrentItem: true });
    }

    return items;
};
